import React, { useEffect, useState } from 'react';

const TxtViewer = ({ url }) => {
  const [textData, setTextData] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTextData = async () => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch text from ${url}`);
        }
        const data = await response.text();
        setTextData(data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchTextData();
  }, [url]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div style={{ width: '100%', height: '100%', overflow: 'auto', whiteSpace: 'pre-wrap', padding:"2rem" }}>
      {textData ? textData : 'Loading text...'}
    </div>
  );
};

export default TxtViewer;